export var RowType;
(function (RowType) {
    RowType[RowType["Row"] = 0] = "Row";
    RowType[RowType["GroupRow"] = 1] = "GroupRow";
})(RowType || (RowType = {}));
